import { eventMiddleware } from 'lib/events';
import { applyMiddleware, compose, createStore } from 'redux';

import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';

import { navigate } from 'components/Navigation/navigationRef';
import { Screens, Stacks } from 'components/Navigation/types';
import { SagaMiddleware } from 'redux-saga';
import { UPGRADE } from './app/actions';
import { CATCH_ERROR } from './error/actions';
import { rootReducer } from './reducer';
import { rootSaga } from './saga';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const createSagaMiddleware = require('redux-saga').default;

const sagaMiddleware: SagaMiddleware<object> = createSagaMiddleware();

const store = __DEV__
  ? createStore(
      rootReducer,
      composeWithDevTools(applyMiddleware(sagaMiddleware, eventMiddleware)),
    )
  : createStore(
      rootReducer,
      compose(applyMiddleware(sagaMiddleware, eventMiddleware)),
    );

const persistor = persistStore(store, null, () => store.dispatch(UPGRADE()));

sagaMiddleware
  .run(rootSaga)
  .toPromise()
  .catch((error) => {
    store.dispatch(CATCH_ERROR({ error }));
    navigate(Stacks.ROOT, Screens.RootError, undefined);
  });

export { store, persistor };
